import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../shared/services/local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private localStorageService: LocalStorageService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {   

        const accessToken = this.localStorageService.getToken();
        const lang = this.localStorageService.getDataByKey('lang') || 'en'; // fallback to 'en' if not set

        // Start with the existing headers
        let headers = request.headers;

        // Always add the lang header
        headers = headers.set('lang', lang);

        // Add Authorization header only if token exists and request is to the API URL
        const isApiUrl = request.url.startsWith(environment.API_BASE_URL);
        if (accessToken && isApiUrl) {
            headers = headers.set('Authorization', `Bearer ${accessToken}`);
        }

        // Clone the request with the updated headers
        request = request.clone({ headers });

        return next.handle(request);
    }
}
